import { createStore, applyMiddleware, compose } from "redux";
import { createEpicMiddleware } from "redux-observable";
import { analytics } from "../common/analytics";

export const configureStore = (reducer, rootEpic, thunk, history) => {
    const composeEnhancers = compose;

    const epicMiddleware = createEpicMiddleware(rootEpic);

    return createStore(
        reducer,
        composeEnhancers(applyMiddleware(epicMiddleware, thunk, history, analytics))
    );
};
